function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M62.378 0.621987C63.2073 1.4513 63.2073 2.79589 62.378 3.6252L37.0075 28.9957C36.1782 29.8251 34.8336 29.8251 34.0043 28.9957L22.153 17.1444L3.6252 35.6722C2.79589 36.5015 1.4513 36.5015 0.621987 35.6722C-0.207329 34.8429 -0.207329 33.4983 0.621987 32.669L20.6514 12.6396C21.4807 11.8103 22.8253 11.8103 23.6546 12.6396L35.5059 24.4909L59.3748 0.621987C60.2041 -0.207329 61.5487 -0.207329 62.378 0.621987Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M42.729 2.1236C42.729 0.950766 43.6798 0 44.8526 0H60.8761C62.0489 0 62.9997 0.950766 62.9997 2.1236V18.1471C62.9997 19.3199 62.0489 20.2707 60.8761 20.2707C59.7033 20.2707 58.7525 19.3199 58.7525 18.1471V4.24719H44.8526C43.6798 4.24719 42.729 3.29642 42.729 2.1236Z"
});

function SvgStocks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 37,
    viewBox: "0 0 63 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStocks);
export default __webpack_public_path__ + "static/media/stocks.46cc274a.svg";
export { ForwardRef as ReactComponent };